import { Inject, Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { CrudGenericsService } from '../common/crud-generics';
import {
  Environment,
  IsError,
  ModelNumStr,
  ITicketCommandAssegna,
  TicketsRegistroStati,
  ITicketsRegistroStati_TableModel,
} from '../../models/-index';
import { Observable } from 'rxjs';

@Injectable()
export class TicketsRegistroStatiService extends CrudGenericsService<TicketsRegistroStati, number> {
  private base: string;

  constructor(protected http: HttpClient, @Inject('ENV') env: Environment) {
    super(http, `${env.apiUrl}/api/TicketsRegistroStati`);
    this.base = `${env.apiUrl}/api/TicketsRegistroStati/`;
  }

  // tutti gli stati
  public GetAllAsync_ByTicketTB(idticket: number): Observable<ITicketsRegistroStati_TableModel[]> {
    const u = this.base + 'GetAllAsync_ByTicketTB?id=' + idticket;
    return this.http.get<ITicketsRegistroStati_TableModel[]>(`${u}`);
  }
  // ultimo stato
  public GetUltimoStato_ByTicketTB(idticket: number): Observable<ITicketsRegistroStati_TableModel> {
    const u = this.base + 'GetUltimoStato_ByTicketTB?id=' + idticket;
    return this.http.get<ITicketsRegistroStati_TableModel>(`${u}`);
  }
  // get persona per il feedback --> Value: idpersona Text: nome cognome
  public GetPersonaForFeedback_ByIdTicket(idticket: number): Observable<ModelNumStr> {
    const u = this.base + 'GetPersonaForFeedback_ByIdTicket?id=' + idticket;
    return this.http.get<ModelNumStr>(`${u}`);
  }
  // metodo prcnipale sostituisce Add
  public TicketsRegistroStati_AddAndPushNotifica(model: TicketsRegistroStati): Observable<IsError> {
    const url = this.base + 'TicketsRegistroStati_AddAndPushNotifica';
    return this.http.post<any>(`${url}`, model);
  }

  // ---- comandi dal web   ------
  public TRS_CommandAssegna(model: ITicketCommandAssegna): Observable<IsError> {
    const url = this.base + 'TRS_CommandAssegna';
    return this.http.post<any>(`${url}`, model);
  }
  public TRS_CommandNotifica(model: ModelNumStr): Observable<IsError> {
    const url = this.base + 'TRS_CommandNotifica';
    return this.http.post<any>(`${url}`, model);
  }

  public TRS_CommandFeedback(model: ModelNumStr): Observable<IsError> {
    const url = this.base + 'TRS_CommandFeedback';
    return this.http.post<any>(`${url}`, model);
  }
  // check se puo' chiudere o meno magar non ha tutte le schede intervento con le date ...
  public TRS_CommandChiude_CheckByTicket(id: number): Observable<IsError> {
    const url = this.base + 'TRS_CommandChiude_CheckByTicket?id=' + id;
    return this.http.get<IsError>(`${url}`);
  }

  // -------------------------
}
